import type { UserData } from "@/types/user";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserState = {
  name: string;
  setName: (name: string) => void;

  pageHeader: string;
  setPageHeader: (pageHeader: string) => void;

  hideHeader: boolean;
  setHideHeader: (hideHeader: boolean) => void;

  isAddingUser: boolean;
  setIsAddingUser: (value: boolean) => void;

  editUserData: UserData | null;
  setEditUserData: (data: UserData | null) => void;

  reset: () => void;
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      name: "",
      setName: (name) => set({ name }),

      pageHeader: "",
      setPageHeader: (pageHeader) => set({ pageHeader }),

      hideHeader: false,
      setHideHeader: (hideHeader) => set({ hideHeader }),

      isAddingUser: false,
      setIsAddingUser: (value) => set({ isAddingUser: value }),

      editUserData: null,
      setEditUserData: (data) => set({ editUserData: data }),

      reset: () =>
        set({
          name: "",
          pageHeader: "",
          hideHeader: false,
          isAddingUser: false,
          editUserData: null,
        }),
    }),
    {
      name: "user-store",
      partialize: (state) => ({
        name: state.name,
      }),
    },
  ),
);
